module.exports = __webpack_public_path__ + "static/media/loader.4cdcf98d.svg";